<template>
  <div>
    <div class="pay-image-header">
      <img src="../assets/china-bank.png" alt='loading'></img>
    </div>
    <div class="payment">
      <div class="pay-header">
        <span class="title-new">Bank of China</span>
        <div class="step-new">
          <el-steps :active="active">
            <el-step icon="el-icon-picture"></el-step>
            <el-step icon="el-icon-picture"></el-step>
            <el-step icon="el-icon-picture"></el-step>
          </el-steps>
          <a class="back-new" href="javascript:void()" @click="lastStep">Back to last step</a>
        </div>

      </div>
      <div class="pay-middle">
        <el-form :model="paymentModel" :rules="paymentRules" ref="paymentForm">
          <div class="pay-one-row row1">
            <span class="row-name1">Merchant Name:</span>
            <span>{{paymentModel.sellerDesc}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name2">Payment Reference:</span>
            <span>{{paymentModel.sellerOrderNo}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name3">FPX Transaction ID:</span>
            <span>{{paymentModel.fpxTransId}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name4">Amount:</span>
            <span>{{paymentModel.transCurrency}}&nbsp;{{paymentModel.transAmount}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name5">Fee Amount:</span>
            <span>{{paymentModel.feeCurrency}}&nbsp;{{paymentModel.feeAmount}}</span>
          </div>

          <div class="pay-one-row">
            <span class="row-name6">From Account:</span>
            <span>{{paymentModel.account}}</span>
          </div>

          <div class="pay-one-row">
            <el-form-item prop="eToken">
              <span class="row-name-token">E-Token pin:</span>
              <input name="a" type="password" placeholder="mima" style="position: absolute;left:99999px"></input>
              <el-input type="password" maxlength="6" class="row-name-token-value" placeholder="Please Input E-Token" v-model="paymentModel.eToken"
                autocomplete="off" :readonly="readOnlyFlag" @focus="readOnlyFlag=false"></el-input>
            </el-form-item>
          </div>

          <div class="pay-button">
            <el-button @click="cancel" type="danger">Cancel</el-button>
            <el-button :disabled="timerStatus" :loading="loadFlag" @click="next" type="danger">Confirm</el-button>
          </div>
        </el-form>
      </div>
      <div class="payfoot"></div>
    </div>
    <ExpirTime ref="expirTime" :startAction="false" @timeoutStatus="timeoutStatus"></ExpirTime>
    <Dialog :dialogVisible="dialogVisible" :errorMessage="errorMessage" @dialogClose="dialogClose"></Dialog>
    <DialogCancel :cancelVisible="cancelVisible" :buttonAble="buttonAble" @cancelDialogClose="cancelDialogClose" @cancelTran="cancelTran"></DialogCancel>
  </div>
</template>

<script>
  import ExpirTime from '../views/ExpirTime'
  import Dialog from '../views/Dialog'
  import DialogCancel from '../views/DialogCancel'
  import service from '@service/service'
  export default {
    name: "PaymentTwo",
    components: {
      ExpirTime: ExpirTime, Dialog, DialogCancel
    },
    data() {
      return {
        readOnlyFlag: true,
        dialogVisible: false,
        cancelVisible: false,
        errorMessage: '',
        buttonAble: false,
        active: 2,
        paymentModel: {
          sellerDesc: '',
          sellerOrderNo: '',
          paymentReference: '',
          fpxTransId: '',
          transCurrency: '',
          transAmount: '',
          feeAmount: '',
          account: '',
          feeCurrency: '',
          eToken: '',
        },
        paymentRules: {
          eToken: [{ required: true, message: 'Please Input E-Token', trigger: 'blur' }]
        },
        loadFlag: false,
        timerStatus: false
      }
    },

    beforeCreate() {
      let pageCount = window.sessionStorage.getItem('pageCount')
      if (pageCount == undefined || pageCount == null) {
        pageCount = 1;
        window.sessionStorage.setItem('pageCount', pageCount)
      } else {
        pageCount++;
        window.sessionStorage.setItem('pageCount', pageCount)
      }
    },

    created() {
      let buyerOrderDetail = JSON.parse(window.sessionStorage.getItem('BuyerOrderDetail'));
      for (let key in this.paymentModel) {
        this.paymentModel[key] = buyerOrderDetail[key];
      }
    },

    methods: {
      timeoutStatus(status) {
        this.timerStatus = status;
        if (this.timerStatus == true) {
          window.sessionStorage.setItem('statusCode', "1J")
        }
      },

      lastStep() {
        this.$router.replace({
          name: 'PaymentOne'
        })
      },

      dialogClose(status) {
        this.dialogVisible = status;
      },

      cancel() {
        this.cancelVisible = true;
      },

      cancelDialogClose(status) {
        this.cancelVisible = false;
      },

      cancelTran() {
        this.cancelVisible = false;
        let statusCode = window.sessionStorage.getItem('statusCode');
        if (statusCode == 'success' || statusCode == 'unSuccess') {
          window.sessionStorage.setItem('message', "Payment Successful you have log out.")
        } else if (statusCode == undefined || statusCode == null || statusCode != '1K') {
          window.sessionStorage.setItem('statusCode', "1L")
          window.sessionStorage.setItem('message', "Payment unsuccessful and you have log out.")
        }
        this.$router.replace({ name: 'ReturnToFpx' })
      },

      next() {
        this.$refs['paymentForm'].validate((valid) => {
          if (valid) {
            this.payment();
          }
        })
      },

      async payment() {
        this.loadFlag = true;
        this.buttonAble = true;
        window.sessionStorage.setItem('opxpPaymentNo', this.paymentModel.paymentReference);

        let pTokenSerial = window.sessionStorage.getItem('eTokNum');
        await this.$http.post(service.payment.submit, {
          opxpPaymentNo: this.paymentModel.paymentReference,
          eToken: this.paymentModel.eToken,
          pTokenSerial: pTokenSerial
        }).then((res) => {
          this.loadFlag = false;
          this.buttonAble = false

          window.sessionStorage.setItem("indirectAC", res.indirectAC)
          if (res.status == 'Unsuccessful') {
            //支付失败
            window.sessionStorage.setItem('statusCode', "unSuccess")
            window.sessionStorage.setItem('Unsuccessful', JSON.stringify(res));
            this.$router.replace({
              name: 'PayErrorPage'
            })
          } else if (res.status == 'Successful') {
            //支付成功
            window.sessionStorage.setItem('statusCode', "success")
            window.sessionStorage.setItem('Successful', JSON.stringify(res));
            this.$router.replace({
              name: 'PaymentThree'
            })
          } else {
            throw new Error('Network request error')
          }
          this.$refs.expirTime.clearTimer();
          window.sessionStorage.removeItem('sessionToken');
        }).catch(error => {
          this.loadFlag = false;
          this.buttonAble = false;
          this.dialogVisible = true;
          this.errorMessage = error.message;

          if (error.message == 'Payment has been completed,please do not repeat payment') {
            let statusCode = window.sessionStorage.getItem('statusCode');
            if (statusCode == undefined || statusCode == null) {
              window.sessionStorage.setItem('statusCode', "success")
            }
          } else {
            window.sessionStorage.setItem('statusCode', "1K")
            window.sessionStorage.setItem('message', "Payment unsuccessful and you have log out.")
          }

        })
      }
    },


  }
</script>

<style lang='less' scoped>
  @media screen and (max-width: 370px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
    }
    @import "../styles/mobile/m_payment.less";
    .timer {
      position: absolute;
      right: 0vw;
      top: 3.8vh;
    }
  }

  @media screen and (min-width: 371px) and (max-width: 400px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
    }

    @import "../styles/mobile_b/m_payment.less";
    .timer {
      position: absolute;
      right: 0vw;
      top: 3.8vh;
    }
  }

  @media screen and (min-width: 401px) and (max-width: 640px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
    }
    @import "../styles/mobile_p/m_payment.less";
    .timer {
      position: absolute;
      right: 0vw;
      top: 3.8vh;
    }
  }

  @media screen and (min-width: 641px) and (max-width: 800px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 200px;
      position: absolute;
    }
    @import "../styles/pad/payment.less";
  }

  @media screen and (min-width: 801px) and (max-width: 1200px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 200px;
      position: absolute;
    }
    @import "../styles/pad_pro/payment.less";
    .timer {
      position: absolute;
      right: 8vw;
      top: 2vh;
    }
  }

  @media screen and (min-width: 1201px) {
    div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 200px;
      position: absolute;
    }
    @import "../styles/pc/payment.less";
  }
</style>


// WEBPACK FOOTER //
// src/views/PaymentTwo.vue